import { createGqlQuery } from '../fetcher';
import { ParticipantTaskTemplates } from '../queries/participantTaskTemplates.query';
import type * as Types from '../types';

export const useParticipantTaskTemplatesQuery = createGqlQuery<
  Types.ParticipantTaskTemplatesQueryVariables,
  Types.ParticipantTaskTemplatesQuery
>(
  (variables) => ['organization', variables.organizationId, 'participantTaskTemplates'],
  ParticipantTaskTemplates,
);
